// Models
import PaymentConditionModel from '@/models/Purchase/PchPaymentCondition'
import ProductModel from '@/models/Warehouse/WhProductToSearch'
import ProviderModel from '@/models/Purchase/PchProvider'
//import PurchaseOrderDetailModel from '@/models/Purchase/PchDetailPurchaseOrder'
import ProductServiceModel from '@/models/Warehouse/WhProductService'
import WarehouseModel from '@/models/Warehouse/WhWarehouse'
import UserModel from '@/models/General/GUser'

// Headers & Filters
import PchDetailPurchaseOrderHeaders from '@/views/Purchase/PchPurchaseOrder/PchDetailPurchaseOrderHeaders'
//import PchDetailPurchaseOrderServiceHeaders from '@/views/Purchase/PchPurchaseOrder/PchDetailPurchaseOrderServiceHeaders'
import ProductFilters from '@/views/Warehouse/WhProduct/list/filters'
//import ProductHeaders from '@/views/Warehouse/WhProduct/list/headers'
import ProductHeaders from '@/views/Warehouse/WhProduct/WhProductHeaders'
import ProductServiceFields from '@/views/Warehouse/WhProductService/WhProductServiceFields'
import ProductServiceFilters from '@/views/Warehouse/WhProductService/WhProductServiceFilters'
import ProductServiceHeaders from '@/views/Warehouse/WhProductService/WhProductServiceHeaders'
import PchDetailPurchaseOrderCreateHeaders from '@/views/Purchase/PchPurchaseOrder/create/headers'

// Rules
import { RequiredRule } from '@/mixins/reusable_mixins/rules'

/**
 * @description
 * Parser of selected collection 'pch_selected_purchase_orders'
 *
 * @param      {object}  props   properties
 * @return     {DetailPurchaseOrder}  detail purchase order class
 */
const selected_parser = props => row => row.toDetailPurchaseOrder({ 
    g_branch_office_id: props.g_branch_office_id 
})

/**
 * @description
 * Generate Create Purchase Order Fields
 *
 * @param      {object}  props   properties
 * @return     {array}  fields array
 */
export default (props) => [
    {
        name: 'g_originator_user_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Responsable',
            model: UserModel,
            noDataText: 'Sin usuarios.',
            noObject: true,
            rules: [RequiredRule],
        },
    },
    {
        name: 'wh_warehouse_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'name',
            itemValue: 'id',
            label: 'Bodega',
            model: WarehouseModel,
            noDataText: 'Sin bodegas.',
            noObject: true,
            rules: [RequiredRule],
        },
        trigger(ctx) {
            //
            const productsFetch = ({ wh_product_id }) =>
                    ProductModel.append('stocks').find(wh_product_id),
                productsList = ctx.value.pch_selected_purchase_orders,
                warehouse_id = ctx.value.wh_warehouse_id
            //
            let branch_id = 0
            //
            Promise.all(productsList.map(productsFetch)).then(products => {
                //
                products.forEach(product => {
                    //
                    const productStock = product.stocks.reduce(
                        (branchStock, branch) => {
                            return (
                                branch.wh_warehouses.reduce(
                                    (warehouseStock, warehouse) => {
                                        if (warehouse.wh_warehouse_id===warehouse_id) branch_id = branch.g_branch_office_id
                                        return warehouse.wh_warehouse_id === warehouse_id
                                            ? warehouseStock +
                                                  (warehouse.logical_stock || 0)
                                            : warehouseStock
                                    },
                                    0
                                ) + branchStock
                            )
                        },
                        0
                    )
                    //
                    const productStockBranch = product.stocks.reduce(
                        (branchStock, branch) => {
                            return (
                                branch.wh_warehouses.reduce(
                                    (warehouseStock, warehouse) => {
                                        return branch.g_branch_office_id === branch_id
                                            ? warehouseStock +
                                                  (warehouse.logical_stock || 0)
                                            : warehouseStock
                                    },
                                    0
                                ) + branchStock
                            )
                        },
                        0
                    )

                    //
                    const productSelected = ctx.value.pch_selected_purchase_orders.find(
                        ({ wh_product_id }) => wh_product_id === product.id
                    )

                    //
                    if (productSelected) {
                        productSelected['stock'] = productStock
                        productSelected['stock_branch'] = productStockBranch
                    }
                })
            })
        },
    },
    {
        name: 'pch_provider_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemKey: 'id',
            itemText: 'rut',
            itemValue: 'id',
            label: 'Rut',
            model: ProviderModel,
            noDataText: 'Sin proveedores.',
            noObject: true,
            rules: [RequiredRule],
        },
        // trigger: props.pch_provider_id_trigger,
    },
    {
        name: 'pch_provider_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemKey: 'id',
            itemText: 'alias_name',
            itemValue: 'id',
            label: 'Proveedor',
            model: ProviderModel,
            noDataText: 'Sin proveedores.',
            noObject: true,
            rules: [RequiredRule],
        },
        trigger: props.pch_provider_id_trigger,
    },
    {
        name: 'pch_provider_branch_offices_id',
        type: 'select',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            items: props.pch_provider_branch_offices,
            itemText: 'address',
            itemValue: 'id',
            label: 'Sucursal',
            noDataText: 'Sin sucursales.',
            rules: [RequiredRule],
        },
    },
    {
        name: 'pch_selected_purchase_orders',
        type: 'table-field',
        flex: {
            'pt-0': true,
            'xs12': true,
            'd-grid': true,
        },
        props: {
            adderProps: {
                formProps: {
                    fields: ProductServiceFields,
                    submitText: 'agregar',
                },
                mapper: props.selected_mapper,
                method: props.selected_method,
                methodError: props.selected_error,
                methodSuccess: props.selected_success,
                model: ProductServiceModel,
                modelKey: 'product_service_id',
                resetData: {
                    is_cyclic: false,
                },
                title: 'Agregar nuevo servicio',
            },
            checkable: true,
            headers: props.is_service ? PchDetailPurchaseOrderHeaders.forService : PchDetailPurchaseOrderCreateHeaders,
            noDataText: 'Sin productos.',
            pickerProps: {
                attachParams: {
                    cost_price_branch_office_id: props.g_branch_office_id,
                    last_provider_code_provider_id: props.pch_provider_id,
                },
                filters: props.is_service ? ProductServiceFilters : ProductFilters,
                headers: props.is_service ? ProductServiceHeaders : ProductHeaders.exclude(['wh_item_is_inventoriable', 'is_repackaged']),
                initialFilterValues: {
                    is_cyclic: props.is_service ? true : undefined,
                },
                mapperFilter: filters => ({
                    ...filters,
                    product_provider_code: props.pch_provider_id && filters.product_provider_code ? `${props.pch_provider_id},${filters.product_provider_code}` : undefined
                }),
                noActions: !props.is_service,
                noPagination: false,
                paramSearch: props.is_service ? 'name' : 'search',
                parser: selected_parser(props),
                rowsPerPage: 15,
                service: props.is_service ? ProductServiceModel : ProductModel,
                submitText: 'confirmar selección',
                title: 'Seleccionar producto',
            },
            selectedKey: props.is_service ? 'wh_product_service_id' : 'wh_product_id',
            showAdder: props.is_service,
            showPicker: true,
            showAdder: props.is_service,
            toolbarTitle: 'Lista de productos incluidos en la orden',
        },
        slots: {
            items: 'table-field-items',
            'picker-actions': 'table-field-picker-actions',
        },
        trigger(ctx) {
            //
            const productsFetch = ({ wh_product_id }) =>
                    ProductModel.append('stocks').find(wh_product_id),
                productsList = ctx.value.pch_selected_purchase_orders,
                warehouse_id = ctx.value.wh_warehouse_id
            //
            let branch_id = 0
            //
            Promise.all(productsList.map(productsFetch)).then(products => {
                //
                products.forEach(product => {
                    //
                    const productStock = product.stocks.reduce(
                        (branchStock, branch) => {
                            return (
                                branch.wh_warehouses.reduce(
                                    (warehouseStock, warehouse) => {
                                        if (warehouse.wh_warehouse_id===warehouse_id) branch_id = branch.g_branch_office_id
                                        return warehouse.wh_warehouse_id === warehouse_id
                                            ? warehouseStock +
                                                  (warehouse.logical_stock || 0)
                                            : warehouseStock
                                    },
                                    0
                                ) + branchStock
                            )
                        },
                        0
                    )
                    //
                    const productStockBranch = product.stocks.reduce(
                        (branchStock, branch) => {
                            return (
                                branch.wh_warehouses.reduce(
                                    (warehouseStock, warehouse) => {
                                        return branch.g_branch_office_id === branch_id
                                            ? warehouseStock +
                                                  (warehouse.logical_stock || 0)
                                            : warehouseStock
                                    },
                                    0
                                ) + branchStock
                            )
                        },
                        0
                    )

                    //
                    const productSelected = ctx.value.pch_selected_purchase_orders.find(
                        ({ wh_product_id }) => wh_product_id === product.id
                    )

                    //
                    if (productSelected) {
                        productSelected['stock'] = productStock
                        productSelected['stock_branch'] = productStockBranch
                    }
                })
            })
        },
    },
    {
        name: 'observation',
        type: 'textarea',
        flex: {
            xs12: true,
        },
        props: {
            label: 'Observación',
        },
    },
    {
        name: 'pch_payment_condition_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'type',
            itemValue: 'id',
            label: 'Método de pago',
            model: PaymentConditionModel,
            noDataText: 'Sin condiciones de pago.',
            noObject: true,
            paramSearch: 'type',
            rules: [RequiredRule],
        },
    },
    {
        name: 'is_exent',
        type: 'switch',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Exento',
        },
    },
    {
        name: 'pch_selected_purchase_orders_net_price',
        type: 'currency-field',
        flex: {
            'offset-lg3': true,
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Total neto',
            readonly: true,
            reverse: true,
        },
    },
]
